export default __webpack_public_path__ + "static/media/golf-icon.a4e47910.svg";